/*
* Credits:
* http://www.codrops.com
*
* Licensed under the MIT license.
* http://www.opensource.org/licenses/mit-license.php
*
* Copyright 2016, Codrops
* http://www.codrops.com
*/
( function ( $ ) {

	'use strict';

	const pluginName = 'liquidReveal';
	let defaults = {
		// If true, then the content will be hidden until it´s "revealed".
		isContentHidden: true,
		// If true,riggred only when element is in view
		animteWhenInView: true,
		delay: 0,
		// The animation/reveal settings. This can be set initially or passed when calling the reveal method.
		revealSettings: {
			// Animation direction: left right (lr) || right left (rl) || top bottom (tb) || bottom top (bt).
			direction: 'lr',
			// Revealer´s background color.
			bgcolor: '#f0f0f0',
			// Animation speed. This is the speed to "cover" and also "uncover" the element (seperately, not the total time).
			duration: 0.5,
			// Animation ease. This is the ease to "cover" and also "uncover" the element.
			ease: 'power4.inOut',
			// percentage-based value representing how much of the area should be left covered.
			coverArea: 0,
			// Callback for when the revealer is covering the element (halfway through of the whole animation).
			onCover: function ( contentEl, revealerEl ) { return false; },
			// Callback for when the animation starts (animation start).
			onStart: function ( contentEl, revealerEl ) { return false; },
			// Callback for when the revealer has completed uncovering (animation end).
			onComplete: function ( contentEl, revealerEl ) { return false; },

			onCoverAnimations: null
		}
	};

	class Plugin {

		constructor( element, options ) {

			this.options = { ...defaults, ...options };

			this._defaults = defaults;
			this._name = pluginName;

			this.element = element;
			this.$element = $( element );
			this.$content = this.$element.children();
			this.revealer = null;

			this.init();

		}

		init() {

			this._layout();

			if ( this.options.animteWhenInView ) {
				this.setIntersectionObserver();
			}
			else {
				imagesLoaded( this.element, this.doTheReveal.bind( this ) );
			}

		}

		_createDOMEl( type, className, content ) {
			var el = document.createElement( type );
			el.className = className || '';
			el.innerHTML = content || '';
			return el;
		}

		_layout() {

			const position = getComputedStyle( this.element ).position;

			if ( position !== 'fixed' && position !== 'absolute' && position !== 'relative' ) {
				this.element.style.position = 'relative';
			}

			// Content element.
			if ( this.options.isContentHidden ) {
				this.$content.css( 'opacity', 0 );
			}

			// Revealer element (the one that animates)
			this.revealer = this._createDOMEl( 'div', 'block-revealer__element' );
			this.element.classList.add( 'block-revealer' );

			this.element.appendChild( this.revealer );

		}

		_getTransformSettings( direction ) {
			var val, origin, origin_2;

			switch ( direction ) {
				case 'lr':
					val = 'scaleX(0)';
					origin = '0 50%';
					origin_2 = '100% 50%';
					break;
				case 'rl':
					val = 'scaleX(0)';
					origin = '100% 50%';
					origin_2 = '0 50%';
					break;
				case 'tb':
					val = 'scaleY(0)';
					origin = '50% 0';
					origin_2 = '50% 100%';
					break;
				case 'bt':
					val = 'scaleY(0)';
					origin = '50% 100%';
					origin_2 = '50% 0';
					break;
				default:
					val = 'scaleX(0)';
					origin = '0 50%';
					origin_2 = '100% 50%';
					break;
			}

			return {
				// transform value.
				val: val,
				// initial and halfway/final transform origin.
				origin: { initial: origin, halfway: origin_2 },
			};
		}

		reveal( revealSettingsArg ) {
			// Do nothing if currently animating.
			if ( this.isAnimating ) {
				return false;
			}
			this.isAnimating = true;

			// Set the revealer element´s transform and transform origin.
			var defaults = {
				duration: 0.5,
				ease: 'power4.inOut',
				delay: this.options.delay ? this.options.delay / 1000 : 0,
				bgcolor: '#f0f0f0',
				direction: 'lr',
				coverArea: 0
			},
				revealSettings = revealSettingsArg || this.options.revealSettings,
				direction = revealSettings.direction || defaults.direction,
				transformSettings = this._getTransformSettings( direction );

			this.revealer.style.WebkitTransform = this.revealer.style.transform = transformSettings.val;
			this.revealer.style.WebkitTransformOrigin = this.revealer.style.transformOrigin = transformSettings.origin.initial;

			// Set the Revealer´s background color.
			if ( !liquidIsElementor ) {
				this.revealer.style.background = revealSettings.bgcolor || defaults.bgcolor;
			}

			// Show it. By default the revealer element has opacity = 0 (CSS).
			this.revealer.style.opacity = 1;

			// Animate it.
			var self = this,
				// Second animation step.
				animationSettings_2 = {
					onComplete: function () {
						self.isAnimating = false;
						if ( typeof revealSettings.onComplete === 'function' ) {
							revealSettings.onComplete( self.content, self.revealer );
						}
						$( self.element ).addClass( 'revealing-ended' ).removeClass( 'revealing-started' );
					}
				},
				// First animation step.
				animationSettings = {
					delay: revealSettings.delay ? revealSettings.delay / 1000 : defaults.delay,
					onComplete: function () {
						self.revealer.style.WebkitTransformOrigin = self.revealer.style.transformOrigin = transformSettings.origin.halfway;
						if ( typeof revealSettings.onCover === 'function' ) {
							revealSettings.onCover( self.content, self.revealer );
						}
						$( self.element ).addClass( 'element-uncovered' );
						gsap.to( self.revealer, {
							...animationSettings_2
						} );
					}
				};

			animationSettings.duration = animationSettings_2.duration = revealSettings.duration ? ( revealSettings.duration / 1000 ) : defaults.duration;
			animationSettings.ease = animationSettings_2.ease = revealSettings.ease || defaults.ease;

			var coverArea = revealSettings.coverArea || defaults.coverArea;
			if ( direction === 'lr' || direction === 'rl' ) {
				animationSettings.keyframes = [
					{ scaleX: 0 },
					{ scaleX: 1, duration: animationSettings.duration },
				];
				animationSettings_2.keyframes = [
					{ scaleX: 1 },
					{ scaleX: coverArea / 100, duration: animationSettings.duration },
				];
			}
			else {
				animationSettings.keyframes = [
					{ scaleY: 0 },
					{ scaleY: 1, duration: animationSettings.duration },
				];
				animationSettings_2.keyframes = [
					{ scaleY: 1 },
					{ scaleY: coverArea / 100, duration: animationSettings.duration },
				];
			}

			if ( typeof revealSettings.onStart === 'function' ) {
				revealSettings.onStart( self.content, self.revealer );
			}
			$( self.element ).addClass( 'revealing-started' );

			gsap.to( self.revealer, {
				...animationSettings
			} );
		}

		setIntersectionObserver() {

			new IntersectionObserver( ( [ entry ], observer ) => {
				if ( entry.isIntersecting ) {
					observer.disconnect();
					$( entry.target ).imagesLoaded( this.doTheReveal.bind( this ) );
				}

			} ).observe( this.element );

		}

		doTheReveal() {

			const onCoverAnimations = this.options.revealSettings.onCoverAnimations || [ { "scale": 0.9 }, { "scale": 1 } ];

			const onCover = {
				onCover: () => {

					if ( this.options.isContentHidden ) {
						this.$content.css( 'opacity', 1 );
					}

					gsap.fromTo( this.element.querySelector( 'figure' ),
						{
							...onCoverAnimations[ 0 ]
						},
						{
							duration: 0.8,
							ease: 'power4.out',
							...onCoverAnimations[ 1 ]
						}
					);

				}
			};

			const options = { ...this.options, ...onCover };

			this.reveal( options );

		}

	}

	$.fn[ pluginName ] = function ( options ) {

		return this.each( function () {

			const pluginOptions = { ...$( this ).data( 'reveal-options' ), ...options };

			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" + pluginName, new Plugin( this, pluginOptions ) );
			}

		} );

	};

}( jQuery ) );

jQuery( document ).ready( function ( $ ) {

	if ( window.$liquidContents.length && window.$liquidContents[ 0 ].hasAttribute( 'data-liquid-stack' ) ) return;

	$( '[data-reveal]' ).filter( ( i, element ) => {

		const $element = $( element );
		const $lazyloadImg = $element.find( '.ld-lazyload' );

		return (
			!$lazyloadImg.length
		);

	} ).liquidReveal();

} );